import { Modal, Button } from "antd";
import { useEffect, useState } from "react";
import { submitReview } from "../apis/callingAPis";
import Cookies from "js-cookie";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";

const ReviewModal = ({
  isreviewModalOpen,
  showreviewModal,
  showpaymentModal,
  resetTimer,
}) => {
  const [rating, setRating] = useState(4);
  const timer = Cookies.get("callDuration");
  const name = Cookies.get("userName");
  const email = Cookies.get("userEmail");

  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    comment: yup.string().required("Comment is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: name,
      email: email,
      comment: "",
      rating: rating,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        await submitReview(
          values.name,
          values.email,
          values.comment,
          values.rating
        );
        toast.success("Review submitted successfully");
        // showpaymentModal();
        showreviewModal();
        formik.resetForm();
        Cookies.remove("callDuration");
        resetTimer();
      } catch (err) {
        console.error(err || "An unexpected error occurred");
        toast.error("Failed to submit review");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleStarClick = (index) => {
    setRating(index + 1);
    formik.setFieldValue("rating", index + 1);
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        stars.push(
          <img
            key={i}
            src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/fillstar.svg"
            alt="filled star"
            className="cursor-pointer"
            onClick={() => handleStarClick(i)}
          />
        );
      } else {
        stars.push(
          <img
            key={i}
            src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/emptystar.svg"
            alt="empty star"
            className="cursor-pointer"
            onClick={() => handleStarClick(i)}
          />
        );
      }
    }
    return stars;
  };

  return (
    <>
      <Modal
        open={isreviewModalOpen}
        onCancel={showreviewModal}
        centered
        footer={null}
        className="white-label-review-modal"
        maskClosable={false}
        closeIcon={null}
      >
        <div className="top-sec">
          <p className="small">Your Call has been ended</p>
          <p className="small">Duration: {timer}</p>
          <p>How was your Experience?</p>
        </div>
        <form onSubmit={formik.handleSubmit} className="review-form">
          <div className="input-wrap">
            <label>Name</label>
            <div className="input-div">
              <img
                src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/name.svg"
                alt="..."
              />
              <input
                type="text"
                placeholder="Enter your Name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
            </div>
            {formik.touched.name && formik.errors.name && (
              <div className="text-red ">{formik.errors.name}</div>
            )}
          </div>
          <div className="input-wrap">
            <label>Email</label>
            <div className="input-div">
              <img
                src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/email.svg"
                alt="..."
              />
              <input
                type="text"
                placeholder="Enter your Email"
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <div className="text-red">{formik.errors.email}</div>
            )}
          </div>
          <div className="input-wrap">
            <label>Share your Experience</label>
            <div className="stars-div">{renderStars()}</div>
            <textarea
              placeholder="Add your comments..."
              name="comment"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.comment}
            ></textarea>
            {formik.touched.comment && formik.errors.comment && (
              <div className="text-red">{formik.errors.comment}</div>
            )}
          </div>
          <div className="buttons">
            <button
              className="cursor-pointer btn-secondary"
              onClick={() => {
                showreviewModal();
                Cookies.remove("callDuration");
                resetTimer();
              }}
            >
              Cancel
            </button>
            <button
              className="cursor-pointer btn-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default ReviewModal;
